import { Fragment } from 'react';
import { Col, Form, Row } from 'react-bootstrap';

import { ControlesLinha, ProcessoInput } from '../../components/RelatorioCivelComponents';

import type { RelatorioCivelStepProps } from './relatorio-civel-step-props';

export default function Step16OutrosProcedimentos(props: RelatorioCivelStepProps) {
  const {
    novoProcessoOutros,
    setNovoProcessoOutros,
    adicionarProcesso,
    setQuantidadeLinhas,
    quantidadeLinhas,
    adicionarMultiplasLinhas,
    isViewMode,
    formData,
    renderTabelaProcessos,
  } = props;

  return (
    <Fragment>
      {!isViewMode && (
        <Row className="mb-4">
          <Col md={12}>
            <Form.Group>
              <Form.Label className="fw-bold">N.º do Processo</Form.Label>
              <ProcessoInput
                value={novoProcessoOutros}
                onChange={setNovoProcessoOutros}
                onAdicionar={() =>
                  adicionarProcesso('outrosProcedimentos', novoProcessoOutros, setNovoProcessoOutros)
                }
              />
              <Form.Text className="text-muted">
                Pressione Enter ou clique em Adicionar para incluir o processo na lista
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>
      )}
      {!isViewMode && (
        <ControlesLinha
          quantidade={quantidadeLinhas.outrosProcedimentos}
          onDecrementar={() =>
            setQuantidadeLinhas((prev) => ({
              ...prev,
              outrosProcedimentos: Math.max(1, prev.outrosProcedimentos - 1),
            }))
          }
          onIncrementar={() =>
            setQuantidadeLinhas((prev) => ({
              ...prev,
              outrosProcedimentos: Math.min(50, prev.outrosProcedimentos + 1),
            }))
          }
          onQuantidadeChange={(value: number) =>
            setQuantidadeLinhas((prev) => ({
              ...prev,
              outrosProcedimentos: value,
            }))
          }
          onAdicionar={() => adicionarMultiplasLinhas('outrosProcedimentos')}
          totalLabel="Total de Processos"
          totalCount={formData.outrosProcedimentos.processos.length}
        />
      )}
      {renderTabelaProcessos('outrosProcedimentos', formData.outrosProcedimentos.processos)}
    </Fragment>
  );
}

